import type { CssPosition } from '../types';

export const buildPositionStyles = (
    top: number = 0,
    left: number = 0,
): CssPosition => ({
    top: `${top}px`,
    left: `${left}px`,
});
